import { MagnifyingGlassIcon } from '@radix-ui/react-icons';
import { Link, useParams } from '@tanstack/react-router';
import { EmptyState } from '@/components/states';
import { Button } from '@/components/ui/button';

export function GameNotFound() {
  const { gameId } = useParams({ strict: false });
  return (
    <EmptyState
      icon={<MagnifyingGlassIcon />}
      title="Game not found"
      description={
        gameId ? `There's no game with ID ${gameId}. It may have been deleted, or the link is out of date.` : undefined
      }
      action={
        <Button variant="outline" asChild>
          <Link to="/games">Back to games</Link>
        </Button>
      }
    />
  );
}
